import { detailsBig, detailsSmall } from "@/styles/typography";
import styled from "styled-components";

const Container = styled.div`
  display: grid;
  position: relative;
  grid-template-columns: 1fr 1fr;
  padding: 70px 0 70px 0;
  width: calc(100% + 140px);
  margin-left: -70px;
  min-height: 400px;
  margin-bottom: 70px;
  background-color: ${({ theme }) => theme.colors.primary};

  @media ${({ theme }) => theme.breakpoints.md} {
    grid-template-columns: 1fr;
    width: 100vw;
    margin-left: -70px;
    padding: 50px;
  }

  @media ${({ theme }) => theme.breakpoints.sm} {
    margin-left: -16px;
    padding: 0 0 50px 0;
  }
`;

const TextWrapper = styled.div`
  margin-top: 20px;
  display: flex;
  flex-direction: column;
  padding: 0 50px 0 70px;
  justify-content: flex-start;

  @media ${({ theme }) => theme.breakpoints.md} {
    margin-top: 50px;
    padding: 0 16px;
  }
`;

const StandingDiagram = styled.div`
  display: flex;
  margin: auto;
  flex-direction: row;
  align-items: flex-end;
  height: 500px;
  width: fit-content;
  padding: 0 50px 0 37px;
  max-width: 100%;
  border-left: 1px solid white;
  border-bottom: 1px solid white;
  gap: 37px;

  @media ${({ theme }) => theme.breakpoints.md} {
    padding: 0 16px;
    gap: 15px;
    width: 80%;
    height: 300px;
  }
`;

const LyingDiagram = styled.div`
  display: flex;
  margin: auto;
  flex-direction: column;
  align-items: flex-start;
  height: 500px;
  width: 500px;
  padding: 37px 0 50px 0;
  max-width: 100%;
  border-left: 1px solid white;
  border-bottom: 1px solid white;
  gap: 37px;

  @media ${({ theme }) => theme.breakpoints.md} {
    padding: 0 16px;
    gap: 15px;
    width: 80%;
    height: 300px;
  }
`;

const Value = styled(detailsSmall)`
  color: black;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  opacity: 0;
  visibility: hidden;
  transition: visibility 0s, opacity 0.3s linear;
`;

const Label = styled(detailsBig)`
  color: white;
  position: absolute;
  bottom: -40px;
  left: 50%;
  transform: translateX(-50%);
  opacity: 0;
  visibility: hidden;
  transition: visibility 0s, opacity 0.3s linear;
  white-space: nowrap;
`;

const LyingLabel = styled(detailsBig)`
  color: white;
  position: absolute;
  left: 50%;
  bottom: -30px;
  text-align: center;
  transform: translateX(-50%);
  opacity: 0;
  visibility: hidden;
  transition: visibility 0s, opacity 0.3s linear;
`;

const StandingBar = styled.div<{ value: number }>`
  position: relative;
  width: 55px;
  height: ${({ value }) => value}%;
  background-color: white;

  @media ${({ theme }) => theme.breakpoints.hover} {
    &:hover {
      ${Value} {
        opacity: 1;
        visibility: initial;
      }

      ${Label} {
        opacity: 1;
        visibility: initial;
      }
    }
  }

  @media ${({ theme }) => theme.breakpoints.md} {
    width: 35px;
  }
`;

const LyingBar = styled.div<{ value: number }>`
  position: relative;
  height: 55px;
  width: ${({ value }) => value}%;
  background-color: white;

  @media ${({ theme }) => theme.breakpoints.hover} {
    &:hover {
      ${Value} {
        opacity: 1;
        visibility: initial;
      }

      ${LyingLabel} {
        opacity: 1;
        visibility: initial;
      }
    }
  }

  @media ${({ theme }) => theme.breakpoints.md} {
    height: 35px;
  }
`;

const PieDiagram = styled.div`
  display: flex;
  flex-direction: column;
`;

const OnePie = styled.div<{ pieData: any }>`
  background-image: repeating-conic-gradient(
    from 0deg,
    #fff 0deg calc(3.6deg * ${({ pieData }) => pieData[0].value}),
    transparent calc(3.6deg * ${({ pieData }) => pieData[0].value}) 360deg
  );
`;

const TwoPie = styled.div<{ pieData: any }>`
  background-image: repeating-conic-gradient(
    from 0deg,
    #fff 0deg calc(3.6deg * ${({ pieData }) => pieData[0].value}),
    #000 calc(3.6deg * ${({ pieData }) => pieData[0].value}) 360deg
  );
`;

const Pie = styled.div`
  width: 400px;
  height: 400px;
  margin: auto;

  @media ${({ theme }) => theme.breakpoints.sm} {
    width: 70%;
    height: 70%;
    padding-bottom: 50px;
  }
`;

const PieLabel = styled(detailsBig)`
  color: white;
  text-align: center;
  margin-top: 20px;
`;

const S = {
  Container,
  TextWrapper,
  StandingDiagram,
  LyingDiagram,
  StandingBar,
  Value,
  Label,
  LyingLabel,
  LyingBar,
  PieDiagram,
  Pie,
  OnePie,
  TwoPie,
  PieLabel,
};

export default S;
